// jpa.js
export default {
  home: {
    title: 'トップページです',
    slogan: '安全を誓い\n' + 'お客様の声に寄り添う\n' + '至高のサービスで\n' + '最上の寛ぎを',
    useCar: 'お問合せ',
    aboutUs: {
      title: 'DDについて',
      content:
        '株式会社DDハイヤーは、東京と大阪を拠点に長年にわたりハイヤー・送迎サービスに携わってきた経験を活かし、ビジネスから観光まで幅広いニーズに対応する車両とサービス体制を整えております。' +
        ' \n \n車両は用途に応じたラインナップをご用意し、すべての車両において定期的な点検・整備を実施し、安全性と快適性を常に最優先しております。' +
        ' \n \nドライバーおよびスタッフは、接遇・安全運転・守秘意識に関する厳格なトレーニングを経た上で業務に従事しており、法人のお客様やVIPのお客様にも安心してご利用いただけます。' +
        ' \n \nまた、株式会社DDハイヤーでは、多国籍・多言語対応のスタッフ体制を整えており、日本語・英語・中国語・韓国語などでの対応が可能です。訪日外国人のお客様や海外法人のお客様にも、スムーズでストレスのない移動体験をご提供いたします。' +
        ' \n \n空港送迎、ビジネス利用、観光チャーター、ゴルフ送迎、時間貸切など、目的に応じた柔軟なチャータープランをご提案可能です。さらに、DDツーリズム株式会社と連携し、日本ならではの魅力を深く体験いただける高品質なツアー・観光アレンジもワンストップでご提供しております。'
    }
  },
  navbar: {
    home: 'トップ',
    carIntroduction: '車種紹介',
    carService: 'ハイヤーサービス',
    addService: '旅行手配',
    clubsSummary: '会社概要',
    contactUs: 'お問い合わせ',
    language: '言語切り替え',
    charteredCar: '日本全国ハイヤー',
    serviceConfiguration: 'サービス',
    serviceAdvantage: '乗用車料金',
    exclusiveService: '専属サービス',
    companyPhilosophy: '会社理念',
    companyProfile: '会社概要',
    serviceContent: 'サービス内容',
    onlineMessage: 'オンラインメッセージ',
    joinUs: 'グループ加入',
    commonQA: 'よくある質問',
    latest: '最新のプッシュ',
    companyName: '株式会社DDハイヤー',
    tourismCompanyName: '株式会社DDツーリズム',
    address: '会社住所'
  },
  routeTitle: {
    home:
      'ジャンボタクシー｜東京・大阪ハイヤー／貸切サービス｜中国語対応ドライバー｜空港送迎｜Tokyo DD',
    carIntroduction: '車種案内で寸',
    carService:
      'ジャンボタクシー｜東京・大阪 空港送迎｜成田・羽田・関西空港送\n' +
      '迎｜東京ビジネスハイヤー｜会議送迎・法人利用｜多国語対応ドライ\n' +
      'バー｜Tokyo DD',
    //旅行服务
    addService:
      'ジャンボタクシー｜東京・関西 一日観光貸切｜オーダーメイド観光\n' +
      'ルート｜多国語対応ドライバー｜Tokyo DD',
    clubsSummary:
      'ジャンボタクシー｜Tokyo DD について｜多国語対応の東京・関西\n' + 'ハイヤーサービス会社',
    contactUs: 'Tokyo DD お問い合わせ｜東京・大阪ハイヤー予約・ご相談',
    pushDetails: 'プッシュ詳細'
  },
  descTitle: {
    home:
      'Tokyo DD は、東京および大阪周辺エリアにて多国語対応ドライ\n' +
      'バーによるハイヤー・貸切サービスを提供しています。空港送迎、ビ\n' +
      'ジネス利用、観光向けカスタムルートまで幅広く対応。日本国内で\n' +
      '正規登録された車両を使用し、料金体系も明確で安心してご利用い\n' +
      'ただけます。',
    carIntroduction: '車両の特徴',
    carService:
      '東京および大阪エリアにて、会議送迎、ビジネス視察、VIP対応に適\n' +
      'したビジネスハイヤーサービスを提供しています。成田空港・羽田空\n' +
      '港・関西国際空港と東京・大阪市内間の多国語対応ドライバーによる\n' +
      '空港送迎に対応。フライトのリアルタイム追跡により、正確かつ安全\n' +
      'な送迎を実現し、ご家族、ビジネス、団体でのご利用にも最適で\n' +
      'す。',
    addService:
      'Tokyo DD では、東京および関西エリアの一日観光向け貸切ハイ\n' +
      'ヤーサービスを提供しています。浅草、銀座、鎌倉、富士山、京都、\n' +
      '奈良など、ご要望に応じて自由にルートをカスタマイズ可能。多国\n' +
      '語対応ドライバーによるご案内で、東京・関西を快適かつ深くお楽し\n' +
      'みいただけます。',
    clubsSummary:
      'Tokyo DD は、日本国内で合法的に登録・運営されているハイ\n' +
      'ヤー・貸切サービス会社です。東京および関西エリア（大阪・京都・\n' +
      '奈良など）において、高品質な貸切車両および空港送迎サービスを\n' +
      '提供しています。',
    contactUs:
      '東京・大阪でのハイヤー利用、空港送迎、ビジネス車両のご予約・ご相談は Tokyo DD までお気軽にお問い合わせください。多国語で\n' +
      'の対応が可能で、迅速かつ信頼性の高いサービスをご提供します。',
    pushDetails: 'プッシュ詳細'
  },
  keywordsTitle: {
    home:
      '東京 ハイヤー, 大阪 ハイヤー, 中国語ドライバー 東京, 中国語ドライ\n' +
      'バー 大阪, 日本 貸切車, 東京 空港送迎',
    carIntroduction: '車両の特徴',
    carService:
      '東京 ビジネスハイヤー, 東京 法人車両, 東京 空港送迎, 大阪 ビジネ\n' +
      'スハイヤー, 大阪 法人車両, 大阪 空港送迎, 成田空港 送迎, 羽田空港 \n' +
      '送迎 ',
    addService:
      '東京 一日観光 ハイヤー, 東京 観光 貸切, 関西 一日観光 ハイヤー, 関\n' + '西 観光 貸切',
    clubsSummary: '東京 ハイヤー会社, 大阪 ハイヤー会社, 日本 ハイヤーサービス',
    contactUs:
      '東京 ハイヤー 予約, 関西 ハイヤー 予約, 多国語ドライバー 東京 問\n' +
      'い合わせ, 多国語ドライバー 関西 問い合わせ',
    pushDetails: 'プッシュ詳細'
  },
  common: {
    language: '语言',
    submit: '送信',
    order: 'お問合せ',
    onlineMsg: {
      process: 'サービスの手順',
      message: 'オンラインメッセージ',
      step1:
        'フォームに基本情報と連絡先を入力し、送信すると、カスタマーサービスがすぐに連絡します。また、直接お電話でお問い合わせいただくこともできます。',
      step2:
        'カスタマーサービスは、ご要望に合わせたサービス提供後の見積もりをご案内いたします。サービス内容と価格を確認した後、サービス料金を支払います。',
      step3:
        '安心のフルサービスで、ドライバーが積極的に連絡を取り、心地よいサポートを提供する、専用車両での上質な旅行をご提供します。'
    },
    successMsg: {
      title: '送信が成功しました'
    },
    formMsg: {
      baseInfo: '基本情報',
      rlus: '入力してください',
      rlusSelect: '選択してください',
      name: {
        label: '名前',
        placeholder: 'お名前を入力してください。例) 山田 太郎'
      },
      email: {
        label: '電子メール',
        placeholder: 'メールアドレスを入力してください。例) xxx@bytedance.com',
        rlus: '正しいメールアドレスの入力をお願いします'
      },
      tel: {
        label: '電話番号',
        placeholder: '海外の番号も対応しています。例) +81356646122',
        rlus: '正しい電話番号をお願いします'
      },
      demand: '利用希望',
      address: {
        label: '出発地',
        placeholder: 'その他の場所は入力してください',
        option: ['成田空港', '羽田空港', '其他空港']
      },
      expectedDate: {
        label: '希望日',
        placeholder: '選択してください。年/月/日'
      },
      flight: {
        label: '予約便',
        placeholder: '例)NH104'
      },
      destination: {
        label: '目的地',
        placeholder: '例)東京都千代田区外神田3-5-5 末広町ハイム'
      },
      peopleNumber: {
        label: '人数',
        placeholder: '乗車人数を入力してください'
      },
      luggageNumber: {
        label: '荷物数',
        placeholder: '荷物数を入力してください'
      },
      contactInformation: {
        label: '連絡希望方法',
        placeholder: ''
      },
      pickUpService: {
        label: '接機服務',
        placeholder: 'お迎えサービスとは、ドライバーが名札を持って空港出口で待機するサービスです。'
      },
      childSeat: {
        label: 'チャイルドシート',
        placeholder: ''
      },
      language: {
        label: '英語/韓国語',
        placeholder: ''
      },
      remark: {
        label: '備考',
        placeholder: '他に要望がある場合は入力してください'
      },
      addService: '追加要望',
      exclusiveService: {
        label: '専用サービス',
        placeholder: ''
      },
      detailService: {
        label: '具体的な要求です',
        placeholder: '所定の時間、場所、要件などを入力します'
      }
    }
  },
  carIntroduction: {
    maximumPassengers: '最大乗用人数',
    maximumPassengersLabel: '乗客',
    maximumPassengersUnit: '人',
    highestPlacement: '最大荷物数',
    highestPlacementLabel: '荷物',
    highestPlacementUnit: '点',
    lowestPrice: '最低料金',
    otherBenefits: '他のメリット',
    swiper1: 'オーダーメイドの\n' + '旅程プラン',
    swiper2: '最高のくつろぎ',
    swiper3: '経験豊富なチーム\n' + 'による安心感',
    swiper4: '安全性と快適性のための\n' + '定期的な車検を実施'
  },
  carService: {
    title: 'ハイヤーサービス',
    swiper1: {
      label: '空港送迎',
      desc:
        '羽田・成田・関空など、主要空港への24時間対応送迎サービス。正確な運行で、快適な旅の始まりと終わりをサポートいたします。'
    },
    swiper2: {
      label: '出張利用',
      desc:
        '役員送迎やビジネス視察に最適。アルファード等の高級車をご用意し、車内でのプライバシーと移動の効率性を約束します。'
    },
    swiper3: {
      label: '観光利用',
      desc:
        '日本全国のプライベートツアー。ベテラン運転手が東京の街並みから京都の史跡、箱根の絶景まで、ご要望に合わせてご案内いたします。'
    },
    swiper4: {
      label: 'ゴルフ送迎 ',
      desc:
        '名門コースへの往復送迎。キャディバッグも余裕を持って積み込める広々とした車両で、プレーに集中できる環境を整えます。'
    },
    swiper5: {
      label: 'その他サービス',
      desc:
        '旅程プランのオーダーメイド、ホテル予約代行、レストラン予約代行、スタジアム予約代行、チケット予約代行などのサービスもご提供します。'
    },
    swiper6: {
      label: '冠婚葬祭',
      desc:
        '結婚式や法事など、大切な儀式の場にふさわしい礼節を尽くした車両サービスを提供いたします。'
    },
    swiper7: {
      label: 'イベント送迎',
      desc:
        '展示会、国際会議、コンサート等の大規模イベントにおけるシャトル運行や、個別のVIP送迎をトータルにサポートいたします。'
    },
    img1: {
      label: '高級モデル',
      desc: '車両はすべて高級モデルであり、定期的にメンテナンスを行い、厳格な管理を行っております。'
    },
    img2: {
      label: 'デラックスキャビン',
      desc:
        '車内は全てラグジュアリーな高級シートが備わっており、長距離の使用でも疲れにくく、快適にくつろいで頂けます。'
    },
    img3: {
      label: '清潔で快適',
      desc:
        '私たちは、1ゲスト1クリーン方式を導入しており、全てのゲストが使用前に徹底的に車両を洗浄・消毒致します。'
    },
    img4: {
      label: 'プロのドライバー',
      desc:
        'ドライバーは全員、専門的で厳格なトレーニングを受けた者で、お客様に安心、親切、くつろぎをご提供致します。'
    },
    chooseUs: {
      title: 'なぜ私たち選ぶのか',
      text1: '「特定大型車」のハイヤーサービス',
      text2: 'プロフェッショナルなトレーニング\n' + 'サービスファースト',
      text3: '安心、安全、快適',
      text4: '遅延などの緊急事態を心配する必要なし',
      text5: '到着ロビーでのお出迎えサービス'
    }
  },
  VehicleExpenses: {
    title1: 'ご利用プラン',
    title2: '料金 (円)',
    title3: '備考・追加料金',
    bigTitle: '車種：アルファード',
    type1: {
      content1: '羽田空港送迎',
      content2: '成田空港送迎',
      content3: '2時間チャーター',
      content4: '4時間チャーター',
      content5: '8時間チャーター'
    },
    type2: {
      content1: '15,000～',
      content2: '30,000～',
      content3: '22,000～',
      content4: '36,800～',
      content5: '64,000～'
    },
    type3: {
      content1: 'ハイエース指定：5,000円 ',
      content2: 'チャイルドシート：3,000円',
      content3: '到着ロビー内でのミートサービス：3,000円',
      content4: '※空港お迎え時、1時間までの待機料金は無料',
      content5: '深夜割増料金：3,000円',
      content6: '延長・超過料金：30分ごとに4,000円\n',
      content7: '※宿泊を伴う場合、運転手の宿泊費は全額お客様負担となります'
    }
  },
  addService: {
    swiper1: {
      title: '旅程オーダーメイド',
      desc:
        'お客様一人ひとりに寄り添う\n' +
        'パーソナルな旅程で、安心と上質な旅を。\n' +
        '専属のオーダーメイド担当者が丁寧に対応し、\n' +
        'ご自身のペースで日本の魅力を\n' +
        '心ゆくまでお楽しみいただけます。'
    },
    swiper2: {
      title: 'ホテル予約代行',
      desc:
        '安心してご旅行いただけ\n' +
        'るよう、ホテルを事前に\n' +
        '代行予約致します。 お客\n' +
        '様のお好みやご要望に合わせて\n' +
        '最適なホテルをご提案し、快適で\n' +
        '満足度の高いご滞在をお届けいたします。'
    },
    swiper3: {
      title: 'レストラン予約代行',
      desc:
        '日本ミシュラン、和食、\n' +
        'その他グルメを代行予約\n' +
        '致します。車での旅行と\n' +
        '同時に本格的な料理を\n' +
        'お楽しみいただけます。'
    },
    swiper4: {
      title: 'ゴルフ予約代行',
      desc:
        'ゴルフ場の利用を前もっ\n' +
        'て計画し、日本のゴルフ\n' +
        '場とサービスを楽しみ、\n' +
        'ゴルフの楽しさを満喫で\n' +
        'きます。'
    },
    swiper5: {
      title: '各種チケット\n' + '予約代行',
      desc:
        'あらゆるイベントチケッ\n' +
        'トの予約を網羅するワン\n' +
        'ストップサービスで、お\n' +
        '気に入りのイベントに簡\n' +
        '単に入場でき、便利で安\n' +
        '全にチケットをご購入頂\n' +
        'けます！'
    },
    info: 'その他のサービスについては、お問い合わせください'
  },
  clubsSummary: {
    info: {
      title: '株式会社DDハイヤー',
      desc:
        '私たちは東京に根差したプロフェッショナルなハイヤー会社として、10年以上にわたる業界経験を活かし、\n' +
        '「「サービス第一、アットホームな心地よさ」を企業理念に、プロフェッショナルかつハイエンドで、\n' +
        '安全性ときめ細やかさを兼ね備えたサービスをご提供しております。\n\n' +
        'また、多国籍のスタッフが在籍しており、日本語・英語・中国語・韓国語など多言語での対応が可能なため、\n' +
        '海外からのお客様にも安心してご利用いただけます。'
    },
    summary: {
      title: '会社概要',
      headQuarters: {
        label: '本社',
        content: '株式会社DDツーリズム'
      },
      representative: {
        label: '代表者',
        content: '望月 輝石'
      },
      headOffice: {
        label: '本社住所',
        content:
          '〒101-0021東京都千代田区外神田3丁目5番5号\n' +
          'TEL：03-6262-9696\n' +
          'FAX：03-5825-4784'
      },
      permitApprovalNumber: {
        label: '許可認可番号',
        content: '東京都知事登録旅行業2-8357'
      },
      managementCompany: {
        label: '運営会社',
        content: '株式会社DDハイヤー'
      },
      representative2: {
        label: '代表者',
        content: '淺井 漢鷹'
      },
      salesOffice: {
        label: '営業所',
        content:
          '〒133-0055東京都江戸川区西篠崎2丁目19番9号\n' +
          'TEL：03-5664-6122\n' +
          'FAX：03-5825-4784'
      },
      permitApprovalNumber2: {
        label: '許可認可番号',
        content: '関自旅ニ第762号'
      }
    },
    address: {
      title: '会社住所',
      info1: {
        name: '本社\n' + '株式会社DDツーリズム',
        detail: '東京都千代田区外神田3丁目5番5号',
        tel: 'TEL：03-6262-9696'
      },
      info2: {
        name: '営業所\n' + '株式会社DDハイヤー',
        detail: '東京都江戸川区西篠崎2丁目19番9号',
        tel: 'TEL：03-5664-6122'
      }
    },
    service: {
      title: 'ハイヤーサービス',
      line1: {
        swiper1: {
          title: '空港送迎',
          desc:
            '到着ロビーにてスタッフがお出迎えいたします。フライト遅延などの不測の事態にも柔軟に対応いたしますので、安心してご利用いただけます。'
        },
        swiper2: {
          title: '出張利用',
          desc: 'ビジネス向け車両と経験豊富なドライバーにより、快適な移動環境をご提供します。'
        },
        swiper3: {
          title: '観光利用',
          desc:
            '日本全国を効率的かつ快適に移動できるため、海外からのご旅行でも、言葉の壁や大きなお荷物、不慣れな移動ルートに関するご心配は不要です。'
        },
        swiper4: {
          title: 'ゴルフ送迎',
          desc:
            'ご指定の出発地からゴルフ場まで快適に送迎いたします。プレー中はドライバーが待機するため、距離のあるコースへの移動や重いゴルフバッグの持ち運びを気にすることなく、身軽にゴルフをお楽しみいただけます。'
        },
        swiper5: {
          title: 'その他サービス',
          desc:
            '旅程プランのオーダーメイド、ホテル予約代行、レストラン予約代行、スタジアム予約代行、チケット予約代行などのサービスもご提供します。'
        }
      },
      line2: {
        swiper1: {
          title: '旅程オーダーメイド',
          desc:
            'パーソナルな旅程で安心の旅を。 専属の旅程オーダーメイド担当者、丁寧なコミュニケーション、ご自身のペースで日本の旅をお楽しみください。'
        },
        swiper2: {
          title: 'ホテル予約代行',
          desc:
            '安心してご旅行いただけるよう、ホテルを事前に代行予約致します。 お客様のお好みに合わせてホテルをご提案し、最高の滞在をお届けします。'
        },
        swiper3: {
          title: 'レストラン予約代行',
          desc:
            '日本ミシュラン、和食、その他グルメを代行予約致します。車での旅行と同時に本格的な料理を楽しんで頂けます。'
        },
        swiper4: {
          title: 'ゴルフ予約代行',
          desc:
            'ゴルフ場の利用を前もって計画し、日本のゴルフ場とサービスを楽しみ、ゴルフの楽しさを満喫できます。'
        },
        swiper5: {
          title: '各種チケット\n' + '予約代行',
          desc:
            'あらゆるイベントチケットの予約を網羅するワンストップサービスで、お気に入りのイベントに簡単に入場でき、便利で安全にチケットをご購入頂けます！'
        }
      },
      title2: '専属サービス'
    }
  },
  pushDetails: {
    backPage: 'ホームページに戻る',
    recentPush: '最近のプッシュ',
    previous: '前ページ',
    next: '次ページ'
  },
  contactUs: {
    JoinUs: 'グループ加入',
    commonQA: 'よくある質問'
  },
  footer: {
    address: '〒133-0055 東京都江戸川区西篠崎2-19-9      エクセル9　911',
    tel: '03 - 5664 - 6122',
    email: 'info@tokyodd.com',
    fax: '03 - 5825 - 4784',
    tourismCompanyAddress: '〒101-0021 東京都千代田区外神田3-5-5 末広町ハイム 8F ',
    tourismCompanyTel: '03 - 6262 - 9696',
    tourismCompanyEmail: 'staff@tokyodd.com',
    tourismCompanyFax: '03 - 5825 - 4784'
  }
}
